import * as React from "react";
import { IconProps } from "./types";

export const CheckboxCheckIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="12"
        viewBox="0 0 12 12"
        width="12"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M10 3L4.5 8.5L2 6"
          strokeWidth="1.6666"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke={color}
        />
      </svg>
    );
  },
);
(CheckboxCheckIcon as React.FunctionComponent).displayName =
  "CheckboxCheckIcon";

export default CheckboxCheckIcon;
